<template>
  <div class="container" id="container-main">
    <div class="row" id="main-row">
      <div id="vapp">
        <div class="header">
          <h1>Customers</h1>
        </div>
        <div class="buttonsGroup">
          <b-tooltip label="View flow" position="is-top"
            ><button class="button is-medium is-success" @click="ViewItem()">
              <b-icon icon="eye" size="is-small"></b-icon>
            </button>
          </b-tooltip>
        </div>
        <template>
          <b-table :data="this.customers" :selected.sync="selected" :loading="this.isLoading" default-sort="id" default-sort-direction="asc" hoverable>
            <b-table-column field="customer_id" label="DiSCTools ID" sortable v-slot="props">
              {{ props.row.customer_id }}
            </b-table-column>
            <b-table-column field="customer_url" label="Customer URL" sortable v-slot="props">
              {{ props.row.customer_url }}
            </b-table-column>
            <b-table-column field="event_name" label="Last Event" sortable v-slot="props">
              {{ props.row.event_name }}
            </b-table-column>
            <b-table-column field="timestamp" label="Last Event At" sortable v-slot="props">
              {{ props.row.timestamp }}
            </b-table-column>
          </b-table>
        </template>
      </div>
    </div>
    <b-loading :is-full-page="true" v-model="bigLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  data: function () {
    return {
      customers: [],
      selected: {},
      isLoading: true,
      bigLoading: false,
      apiUrl: "https://api.jeak.co.uk",
    };
  },
  methods: {
    GetItems: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios
        .get(this.apiUrl + "/customerevents", config)
        .then((response) => {
          this.customers = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
        });
    },
    ViewItem: function () {
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to view first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        this.$router.push({ path: "/voiceplus/customers/wizardstatus/" + this.selected.customer_id });
      }
    },
  },
  mounted() {
    this.GetItems();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
